import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CoverageElementsTable from "@/components/tables/coverage_elements/CoverageElementsTable.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageElementsTableView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoverageElementsTable))
}
}

})